import { AdobeAnalyticsBody } from '@cx-web/components/third-party/adobe-analytics';
import { GoogleTagManagerBody } from '@cx-web/components/third-party/google-tag-manager';
import { REPUB_CONFIG } from '@cx-web/repub-config';
import { Outlet, Scripts, ScrollRestoration, useLoaderData, useLocation } from '@remix-run/react';
import { ExternalScripts } from 'remix-utils/external-scripts';

import { usePlusConfig } from '~/apps/product-plus/providers/plus-config-context';
import { featureFlags, useFeatureFlag } from '~/providers/feature-flag-provider';

import { type loader } from './root-loader';

export default function Body() {
  const rootLoaderData = useLoaderData<typeof loader>();
  if (!rootLoaderData) {
    throw new Error('Root loader data is missing');
  }

  const { pathname } = useLocation();
  const disableGtm = useFeatureFlag(featureFlags.DISABLE_GOOGLE_TAG_MANAGER);
  const disableOffersWidgets = useFeatureFlag(featureFlags.DISABLE_OFFER_WIDGETS);

  const { ENV, gtmId, repub, resourcesUrl } = rootLoaderData;

  const { uiBehavior } = usePlusConfig();
  const theme = uiBehavior.theme;

  return (
    <body
      data-fpsm-theme={theme}
      data-template={pathname.split('/').slice(1).join('_')}
      style={
        theme === 'whoscored'
          ? ({
              '--ws-background-url': `url(${resourcesUrl}/assets/img/plus/ws-background.png)`,
            } as React.CSSProperties)
          : undefined
      }
    >
      {!REPUB_CONFIG[repub]?.tracking?.usesConsentGatedGTM && (
        <GoogleTagManagerBody
          gtmId={gtmId}
          shouldRender={!disableGtm && (ENV.ENVIRONMENT === 'PROD' || ENV.ENVIRONMENT === 'STG')}
        />
      )}
      {repub === 'GZ' && <AdobeAnalyticsBody />}
      <Outlet context={rootLoaderData} />
      <script
        dangerouslySetInnerHTML={{
          __html: `window.ENV = ${JSON.stringify(ENV)}`,
        }}
      />
      <ScrollRestoration />
      {!disableOffersWidgets && <ExternalScripts />}
      <Scripts />
    </body>
  );
}
